import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class RelatedCardStore {

}

export enum RelatedCardStoreKeys {

}
